import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import FullPageLoader from './components/FullPageLoader';
import { installAuthInterceptors, whenAuthReady } from './lib/auth';
import { initDatadog } from './utils/datadog';
import { initPendo } from './utils/pendo';

// Observability and the axios auth interceptors exist before anything renders
// or issues a request.
initDatadog();
initPendo();
installAuthInterceptors();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

// Resolve the session (finishing the Auth0 redirect callback) before the app
// mounts, so everything downstream reads a settled auth state.
root.render(<FullPageLoader />);
whenAuthReady().then(() => {
  root.render(<App />);
});
